import type { MateriaColor } from "../types/MateriaColor"

export const getCssColor = (color: MateriaColor | undefined) => {
  if (color === undefined) return undefined
  return `var(--color-${color})`
}
